import React from "react";
const AlbumDetailsHeroIcons = ({singleAlbumContext,setshowTitle, showTitle}) => {
  const textLabel = !showTitle ? photoOrg.translations.photos["show_photo_titles"] : photoOrg.translations.photos["hide_photo_titles"]
     return (
      <div>
        <div className="album-detail-hero-icons">
          <div className="album-left-buttons">
          <div className="sort_single_album_sec">
          <div className="signin-msg" name="public_share_sign_in">
            <p className="share_login_link">
              <a onClick={() => photoOrg.Util.getLoginRedirectUrl(true)} href="javascript:void(0)" data-testid="btn_login" aria-label={ photoOrg.translations.photos["aria_label"]["click_to_signin"]}>{photoOrg.translations.photos["action_container"]["sign_in_join"]} 
              </a>
              {photoOrg.translations.photos["action_container"]["sign_in_extra"]}
            </p>
          </div>
        </div>                  
      </div>              

      <div className={`album-right-buttons  ${ (singleAlbumContext.accessType == 'sharedWithMe')? 'friends-album' : 'owned-myshared-album' }`}>
        <ul id="show-sav-titles" className="dropdown-button ev-photo-title photo_title_cv album-hero-button" name="cv_photo_title" role="button">
          <li>
            <a onClick={()=>setshowTitle(!showTitle)} aria-label={textLabel} data-testid="btn_toggle">
              <span className="icon-icon_captions sub-icon"></span>
              <span className="photo-title-label">{textLabel}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
)
}
  
export default AlbumDetailsHeroIcons;